import React from 'react';

const MESSAGE = 'FREE SHIPPING ALL OVER INDIA 🔥🔥🔥';
// Enough copies that the strip is always wider than the viewport, even on
// large desktop screens, so the loop never shows a gap.
const COPIES = 8;

const PromoBanner = () => {
  // Rendered twice back-to-back, identical — translateX(-50%) then shifts by
  // exactly one full copy's width, which is what makes the loop seamless.
  const items = Array.from({ length: COPIES * 2 });

  return (
    <div className="promo-banner">
      <span className="sr-only">Free shipping all over India</span>
      <div className="promo-banner-track" aria-hidden="true">
        {items.map((_, i) => (
          <span className="promo-banner-item" key={i}>{MESSAGE}</span>
        ))}
      </div>
    </div>
  );
};

export default PromoBanner;
